import React, { ReactNode } from 'react';
import { AuthProvider } from './auth';
import { DropDownProvider } from './dropdown';
import { CheckoutInfoProvider } from './useCheckoutInfo';
import { UseTranslationProvider } from './useTranslation';
import { ToastProvider } from './toast';
import { CheckoutFunctionProvider } from './useCheckoutFunctions';
import { NotificationProvider } from './notification';
import { ScrollProvider } from './ScrollContext';

interface CheckoutInfoProviderProps {
  children: ReactNode;
}

const AppProvider: React.FC<CheckoutInfoProviderProps> = ({ children }: CheckoutInfoProviderProps) => (
  <UseTranslationProvider>
    <NotificationProvider>
      <ToastProvider>
        <AuthProvider>
          <DropDownProvider>
            <CheckoutInfoProvider>
              <CheckoutFunctionProvider>
                <ScrollProvider>
                 {children}
                </ScrollProvider>
              </CheckoutFunctionProvider>
            </CheckoutInfoProvider>
          </DropDownProvider>
        </AuthProvider>
      </ToastProvider>
    </NotificationProvider>
  </UseTranslationProvider>
);
export default AppProvider;
